// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { Navigate } from 'react-router-dom';
import { useInboundCollateralAgreementRequestCount } from '../../hooks/other/useInboundCollateralAgreementRequests';
import { useInboundInstructedCollateralCount } from '../../hooks/other/useInstructedCollateralNotifications';
import { Collaterals } from '../../pages/collateral/collaterals/Collaterals';
import { Configurations } from '../../pages/collateral/configuration/Configurations';
import { Onboarding } from '../../pages/collateral/onboarding/Onboarding';
import { Agreements } from '../../pages/collateral/user/Agreements';
import { ModuleRoute } from '../../routes/types';

export const baseRoutes: ModuleRoute[] = [
  { index: true, element: <Navigate to="onboarding" /> },
  { label: 'Onboarding', path: 'onboarding', element: <Onboarding /> },
];

export const operatorRoutes: ModuleRoute[] = [
  { label: 'Configurations', path: 'configurations', element: <Configurations /> },
];

export const userRoutes: ModuleRoute[] = [
  {
    label: 'Agreements',
    path: 'agreements',
    element: <Agreements />,
    getNotificationHook: useInboundCollateralAgreementRequestCount,
  },
  {
    label: 'Collateral',
    path: 'collaterals',
    element: <Collaterals />,
    getNotificationHook: useInboundInstructedCollateralCount,
  },
];

export const routes: ModuleRoute[] = [...baseRoutes, ...userRoutes, ...operatorRoutes];
